// @ts-nocheck
import React from 'react';
import initialState from '/aoneci/runner/work/source/packages/commerce/src/.umi-production/plugin-initial-state/models/initialState';
import model0 from "/aoneci/runner/work/source/packages/commerce/src/models/account";
import model1 from "/aoneci/runner/work/source/packages/commerce/src/models/order-status";
import model2 from "/aoneci/runner/work/source/packages/commerce/src/models/permission";
import model3 from "/aoneci/runner/work/source/packages/commerce/src/models/user";
import model4 from "/aoneci/runner/work/source/packages/commerce/src/pages/AfterSale/Detail/models/usePageLayout";
import model5 from "/aoneci/runner/work/source/packages/commerce/src/pages/OrderManagement/OrderDetail/models/usePageLayout";
import model6 from "/aoneci/runner/work/source/packages/commerce/src/pages/Product/Category/models/active-category";
import model7 from "/aoneci/runner/work/source/packages/commerce/src/pages/Product/Category/models/shrink";
import model8 from "/aoneci/runner/work/source/packages/commerce/src/pages/Product/Management/models/puzzle-table";
import model9 from "/aoneci/runner/work/source/packages/commerce/src/pages/Product/Review/List/models/review-list";
// @ts-ignore
import Dispatcher from './helpers/dispatcher';
// @ts-ignore
import Executor from './helpers/executor';
// @ts-ignore
import { UmiContext } from './helpers/constant';

export const models = { '@@initialState': initialState, 'account': model0, 'order-status': model1, 'permission': model2, 'user': model3, 'AfterSale.Detail.usePageLayout': model4, 'OrderManagement.OrderDetail.usePageLayout': model5, 'Product.Category.active-category': model6, 'Product.Category.shrink': model7, 'Product.Management.puzzle-table': model8, 'Product.Review.List.review-list': model9 };

export type Model<T extends keyof typeof models> = {
  [key in keyof typeof models]: ReturnType<typeof models[T]>;
};

export type Models<T extends keyof typeof models> = Model<T>[T]

const dispatcher = new Dispatcher!();
const Exe = Executor!;

export default ({ children }: { children: React.ReactNode }) => {

  return (
    <UmiContext.Provider value={dispatcher}>
      {
        Object.entries(models).map(pair => (
          <Exe key={pair[0]} namespace={pair[0]} hook={pair[1] as any} onUpdate={(val: any) => {
            const [ns] = pair as [keyof typeof models, any];
            dispatcher.data[ns] = val;
            dispatcher.update(ns);
          }} />
        ))
      }
      {children}
    </UmiContext.Provider>
  )
}
